"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importDefault(require("react"));
const hooks_1 = require("../hooks");
exports.ContentImportPanelClosePanelButton = () => {
    const { onClose } = hooks_1.useContentImportPanelUpdate();
    return (react_2.default.createElement(react_1.OsmosysDiv, { osysName: "ContentImportPanel.toolbar.inner", flexColCentered: true },
        react_2.default.createElement(react_1.OsmosysButton, { osysName: "ContentImportPanel.close", osysIcon: "close", osysStyle: "navLink", tooltip: "Close", className: "p-1", onClick: () => {
                onClose();
            } })));
};
//# sourceMappingURL=ClosePanelButton.js.map